import { type CrmRelationsParticuliereRelatieDto } from '@services/crm-public/orval-api/model/crmRelationsParticuliereRelatieDto';
import { type CrmRelationsRelatieContext } from '@services/crm-public/orval-api/model/crmRelationsRelatieContext';
import { type CrmRelationsZakelijkeRelatieDto } from '@services/crm-public/orval-api/model/crmRelationsZakelijkeRelatieDto';
import { TechnicalError } from '@errors/sbError';
import { toDateonly } from '@tools/dates';
import { isParticuliereRelatie, isZakelijkeRelatie, type Relatie } from './types';

export function mapToDto<T extends Relatie>(relatie: T, context?: CrmRelationsRelatieContext) {
  if (context === undefined) throw new TechnicalError('Relatiecontext onbekend.');

  const rekening = !relatie.rekening?.iban && !relatie.rekening?.bic ? undefined : relatie.rekening;

  if (isZakelijkeRelatie(relatie)) {
    return {
      ...relatie,
      rekening,
      relatieContext: context,
    } as CrmRelationsZakelijkeRelatieDto;
  }

  if (isParticuliereRelatie(relatie)) {
    return {
      ...relatie,
      rekening,
      relatieContext: context,
      geboortedatum: relatie.geboortedatum ? toDateonly(relatie.geboortedatum) : undefined,
    } as CrmRelationsParticuliereRelatieDto;
  }
  throw new TechnicalError('Relatie niet zakelijk of particulier');
}
